import Lang from '../Lang'
import cn from './cn'
import hk from './hk'

const langIns = new Lang({cn, hk})
module.exports = function lang(key, params){
	return langIns.getText(key, params)
}


// WEBPACK FOOTER //
// ./js/src/i18n/purchase/index.js